<template>
    <div style="width:100%">
        <input :type="show_field ? 'text' : 'hidden'" :name="field_name" v-model="calendarData.selectedDate">
        <FunctionalCalendar
            v-model="calendarData"
            :is-date-range=is_date_range
            :is-date-picker=is_date_picker
            :disabled-dates=disabled_dates
            :day-names=day_names
            :is-layout-expandable="true"
        ></FunctionalCalendar>
        <template v-if="show_formatted">
            <template v-if="formatted_date">
                You selected <b>{{ formatted_date }}</b>
            </template>
            <template v-else>
                Please select a date above
            </template>
        </template>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from "vuex"; 
    import { FunctionalCalendar } from 'vue-functional-calendar';
    export default {
        components: {
            FunctionalCalendar
        },
            
        props: [
            'is_date_range',
            'is_date_picker',
            'disabled_dates',
            'day_names',
            'field_name',
            'show_field',
            'show_formatted'
        ],
            
        data() {
            return {
                calendarData: {}
            }
        },

        computed: {
            formatted_date: function () {
                if (Object.keys(this.calendarData).length > 0 && this.calendarData.selectedDate) {
                    var dateParts = this.calendarData.selectedDate.split("/");
                    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                    return dateObject.toDateString();
                }
                return null;
            },
	    },
        
        watch: {
        },
        
        created: function() {
        },
        
        methods: {
        },
    }
</script>